import React from "react";
import { Stack } from "@mui/material";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const BottomBar = ()=> {
    
  const handleClick=(icon:string)=>{
    let url =''
    
    if(icon ==='github'){
      url = 'https://github.com/saraha194'
    } else {
      url = 'https://uk.linkedin.com/in/sarah-ward-1a310681'
    }
    window.open(url,'_blank')
  }
  
  return (
      
      <Stack 
        className="BottomBar" 
        direction={'row'}
        spacing={2}
        sx={{
          backgroundColor:'#420A02', 
          color: '#fff', 
          width:'100%', 
          height:'7.5vh',
          justifyContent: "center",
          alignItems: "center", 
          }}>
         <GitHubIcon 
            color='secondary' 
            fontSize="large" 
            onClick={()=>handleClick('github')} 
            sx={{ '&:hover':{
              cursor:'pointer'
            }}}>
          </GitHubIcon>
          <LinkedInIcon 
            color='secondary' 
            fontSize="large" 
            onClick={()=>handleClick('linkedin')}  
            sx={{ '&:hover':{
              cursor:'pointer'
            }}}>
          </LinkedInIcon>
      </Stack>
    );
  }
  
  export default BottomBar;